import styled from "styled-components";

export const BreakLine = styled.br`

`